import { Dispatch, SetStateAction } from 'react';

import { Button, Stack, Typography } from '@mui/material';

import { ContentModal } from 'components/modal';
import { SubTitle } from 'components/text';
import { useQueryTotalizador, useRefazerQuebras } from 'pages/compra/configuracao-pedido/hooks';

interface ConfiguracaoPedidoCompraSazonalModalProps {
    message: string;
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export function ConfigPedidoRefazerQuebrasModal({ open, setOpen, message }: ConfiguracaoPedidoCompraSazonalModalProps) {
    const { refetch, data: configPedidoOrigem, isFetching: isFetchingRefazerQuebras } = useRefazerQuebras();
    const { isFetching: isFetchingTotalizador } = useQueryTotalizador({ configPedido: configPedidoOrigem });

    return (
        <ContentModal open={Boolean(open)} setOpen={setOpen} closeButton sx={{ borderRadius: 1, maxWidth: 700 }}>
            <SubTitle label="Aviso" />

            <Typography align="justify">{message}</Typography>

            <Stack direction="row" sx={{ justifyContent: 'flex-end', gap: 2, pt: 2 }}>
                <Button variant="contained" loading={isFetchingRefazerQuebras || isFetchingTotalizador} onClick={() => refetch()}>
                    Refazer Quebras
                </Button>

                <Button variant="outlined" onClick={() => setOpen(false)}>
                    Fechar
                </Button>
            </Stack>
        </ContentModal>
    );
}
